import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  TableRow,
  TableCell,
} from '@material-ui/core';

import TableActions from '../TableActions';
import AlertDialog from '../AlertDialog';

class Row extends PureComponent {
  constructor() {
    super();

    this.state = {
      alert: false,
    };

    this.toggleAlert = this.toggleAlert.bind(this);
  }

  handleShow(id) {
    this.props.history.push(`/admins/${id}`);
  }

  handleEdit(id) {
    this.props.history.push(`/admins/${id}/edit`);
  }

  toggleAlert() {
    this.setState({ alert: !this.state.alert });
  }

  render() {
    const { alert } = this.state;
    const {
      admin: {
        id,
        email,
        username,
        first_name,
        last_name,
      },
      onDelete,
    } = this.props;

    return (
      <TableRow
        hover
        tabIndex={-1}
      >
        <TableCell width={50}>{id}</TableCell>
        <TableCell padding="none">{`${first_name} ${last_name}`}</TableCell>
        <TableCell padding="none">{username}</TableCell>
        <TableCell padding="none">{email}</TableCell>
        <TableActions
          onShow={() => this.handleShow(id)}
          onEdit={() => this.handleEdit(id)}
          onDestroy={() => this.toggleAlert()}
        />
        <AlertDialog
          isOpen={alert}
          title="¿Desea borrar el usuario administrador?"
          handleClose={this.toggleAlert}
          handleAccept={() => onDelete(id)}
        />
      </TableRow>
    );
  }
}

export default Row;

Row.propTypes = {
  admin: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Admins/Row.js